import { Text } from '@chakra-ui/react';

import {
    AccountConstraint,
    CashAllocation,
    ConvictionAllocation,
    GrowthAllocation,
    SecuredAllocation,
    TradePlanDetailType,
} from '../../../_openapi/portfolio-optimizer';
import { AllocationTablesData, AllocationTablesView } from '../../../Portfolio/PortfolioAllocationTables';
import { GrowthAllocationInputChart, hasGrowthAllocationInput } from './GrowthAllocationInputChart';
import { findDetailJson, findDetailRecord, type TradeDetailRecord } from './tradeDetailsModel';

const ALLOCATION_DETAIL_TYPES = [
    TradePlanDetailType.ACCOUNT_CONSTRAINT,
    TradePlanDetailType.CASH_ALLOCATION,
    TradePlanDetailType.GROWTH_ALLOCATION,
    TradePlanDetailType.SECURED_ALLOCATION,
    TradePlanDetailType.CONVICTION_ALLOCATION,
] as const;

export const hasOptimizerAllocationData = (details: TradeDetailRecord[]): boolean =>
    ALLOCATION_DETAIL_TYPES.some((t) => findDetailJson(details, t).length > 0);

export const toAllocationTablesData = (details: TradeDetailRecord[]): AllocationTablesData => ({
    accountConstraint: findDetailRecord<AccountConstraint>(details, TradePlanDetailType.ACCOUNT_CONSTRAINT),
    cashAllocation: findDetailJson<CashAllocation>(details, TradePlanDetailType.CASH_ALLOCATION),
    securedAllocation: findDetailJson<SecuredAllocation>(details, TradePlanDetailType.SECURED_ALLOCATION),
    convictionAllocation: findDetailJson<ConvictionAllocation>(details, TradePlanDetailType.CONVICTION_ALLOCATION),
    growthAllocation: findDetailJson<GrowthAllocation>(details, TradePlanDetailType.GROWTH_ALLOCATION),
});

export const OptimizerAllocationTables = ({ details }: { details: TradeDetailRecord[] }) => (
    <AllocationTablesView
        allocation={toAllocationTablesData(details)}
        cashAllocationAside={<GrowthAllocationInputChart details={details} />}
    />
);

/** An account's allocation output as shown in the Advanced view, or the empty state when the run stored none. */
export const AccountAllocationTables = ({ details }: { details: TradeDetailRecord[] }) =>
    hasOptimizerAllocationData(details) || hasGrowthAllocationInput(details) ? (
        <OptimizerAllocationTables details={details} />
    ) : (
        <Text>No allocations found</Text>
    );
